import { nextSeenFilter } from '../_lib/seen-filter'
import type { LibraryAction } from './actions'
import type { CurriculumState } from './contracts'
import { cloneFilterNodes } from './initial-state'

export const libraryReducer = (
  state: CurriculumState,
  action: LibraryAction,
): CurriculumState => {
  if (action.type === 'apply-preset') {
    return {
      ...state,
      filters: cloneFilterNodes(action.preset.filters),
      sorts: action.preset.sorts.map((sort) => ({ ...sort })),
      typeFilter: action.preset.typeFilter,
      flash: `⚡ Preset "${action.preset.label}" applied — filters and sorts snapped. Tweak them freely; the chip un-highlights once you diverge.`,
    }
  }

  if (action.type === 'set-filters') {
    return { ...state, filters: cloneFilterNodes(action.filters) }
  }
  if (action.type === 'set-sorts') {
    return { ...state, sorts: action.sorts.map((sort) => ({ ...sort })) }
  }
  if (action.type === 'set-type-filter') {
    return { ...state, typeFilter: action.filter }
  }
  if (action.type === 'cycle-company-tag') {
    const index = state.companyTags.findIndex(
      (tag) => tag.company.toLowerCase() === action.company.toLowerCase(),
    )
    if (index === -1) {
      return {
        ...state,
        companyTags: [
          ...state.companyTags,
          { company: action.company, mode: 'include' },
        ],
      }
    }
    const current = state.companyTags[index]
    if (current.mode === 'exclude') {
      return {
        ...state,
        companyTags: state.companyTags.filter((_, tagIdx) => tagIdx !== index),
      }
    }
    return {
      ...state,
      companyTags: state.companyTags.map((tag, tagIdx) =>
        tagIdx === index ? { ...tag, mode: 'exclude' } : tag,
      ),
    }
  }
  if (action.type === 'cycle-seen-filter') {
    return { ...state, seenFilter: nextSeenFilter(state.seenFilter) }
  }
  if (action.type === 'toggle-column') {
    return {
      ...state,
      hiddenCols: state.hiddenCols.includes(action.column)
        ? state.hiddenCols.filter((column) => column !== action.column)
        : [...state.hiddenCols, action.column],
    }
  }
  if (action.type === 'set-column-order') {
    return { ...state, columnOrder: [...action.order] }
  }
  if (action.type === 'set-library-tab') {
    return { ...state, libraryTab: action.tab }
  }

  return state
}
